import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetSalesComparisonQueryVariables = Types.Exact<{
  dateBasis?: Types.InputMaybe<Types.SalesComparisonDateBasis>;
  excludeInitialized?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  shipFromSiteLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  metric: Types.SalesComparisonMetric;
  groupBy: Types.SalesComparisonGroupBy;
  periodAFrom: Types.Scalars['DateTime']['input'];
  periodATo: Types.Scalars['DateTime']['input'];
  periodBFrom: Types.Scalars['DateTime']['input'];
  periodBTo: Types.Scalars['DateTime']['input'];
  salesPerson?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Types.SalesComparisonSort>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetSalesComparisonQuery = { __typename?: 'Query', reportSalesComparisonData: { __typename?: 'ReportSalesComparisonDataPayload', totalCount: number, totalMatching: number, data: Array<{ __typename?: 'ReportSalesComparisonData', groupKey: string, groupLabel: string, periodATotal: number, periodBTotal: number, delta: number, percentChange?: number | null, orderCountA: number, orderCountB: number }> } };

export type GetCustomerAgingQueryVariables = Types.Exact<{
  agingDate: Types.Scalars['DateTime']['input'];
  reportType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  salesPersonEmail?: Types.InputMaybe<Types.Scalars['String']['input']>;
  minBalance?: Types.InputMaybe<Types.Scalars['Decimal']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCustomerAgingQuery = { __typename?: 'Query', reportCustomerAgingData: { __typename?: 'ReportCustomerAgingDataPayload', totalCount: number, totalMatching: number, data: Array<{ __typename?: 'ReportCustomerAgingDataRow', customerId: string, customerName: string, salesPerson: string, orderNumber: string, terms: string, transactionDate?: Types.TDateISO | null, daysPastDue?: number | null, current: number, days1To30: number, days31To60: number, days61To90: number, days90Plus: number, interest: number, totalDue: number }> } };


export const GetSalesComparisonDocument = new TypedDocumentString(`
    query GetSalesComparison($dateBasis: SalesComparisonDateBasis, $excludeInitialized: Boolean, $shipFromSiteLocationId: String, $metric: SalesComparisonMetric!, $groupBy: SalesComparisonGroupBy!, $periodAFrom: DateTime!, $periodATo: DateTime!, $periodBFrom: DateTime!, $periodBTo: DateTime!, $salesPerson: String, $sort: SalesComparisonSort, $first: Int) {
  reportSalesComparisonData(
    dateBasis: $dateBasis
    excludeInitialized: $excludeInitialized
    shipFromSiteLocationId: $shipFromSiteLocationId
    metric: $metric
    groupBy: $groupBy
    periodAFrom: $periodAFrom
    periodATo: $periodATo
    periodBFrom: $periodBFrom
    periodBTo: $periodBTo
    salesPerson: $salesPerson
    sort: $sort
    first: $first
  ) {
    totalCount
    totalMatching
    data {
      groupKey
      groupLabel
      periodATotal
      periodBTotal
      delta
      percentChange
      orderCountA
      orderCountB
    }
  }
}
    `);
export const GetCustomerAgingDocument = new TypedDocumentString(`
    query GetCustomerAging($agingDate: DateTime!, $reportType: String, $salesPersonEmail: String, $minBalance: Decimal, $first: Int) {
  reportCustomerAgingData(
    agingDate: $agingDate
    reportType: $reportType
    salesPersonEmail: $salesPersonEmail
    minBalance: $minBalance
    first: $first
  ) {
    totalCount
    totalMatching
    data {
      customerId
      customerName
      salesPerson
      orderNumber
      terms
      transactionDate
      daysPastDue
      current
      days1To30
      days31To60
      days61To90
      days90Plus
      interest
      totalDue
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetSalesComparison: build.query<GetSalesComparisonQuery, GetSalesComparisonQueryVariables>({
      query: (variables) => ({ document: GetSalesComparisonDocument, variables })
    }),
    GetCustomerAging: build.query<GetCustomerAgingQuery, GetCustomerAgingQueryVariables>({
      query: (variables) => ({ document: GetCustomerAgingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetSalesComparisonQuery, useLazyGetSalesComparisonQuery, useGetCustomerAgingQuery, useLazyGetCustomerAgingQuery } = injectedRtkApi;
